import { AnalyticsEvent } from '@shure/shared/models';

/**
 * Interface to enable access to the analyticsService.
 * Should be consumed via DI in client class and create new analytics instance.
 */
export abstract class AnalyticsProvider {
	/**
	 * Analytics opted in status
	 * Informs provider to process events
	 */
	public abstract optIn(): void;

	/**
	 * Analytics opted out status
	 * Informs provider to stop processing events
	 */
	public abstract optOut(): void;

	/**
	 * Process incoming events
	 */
	public abstract trackEvent<T extends AnalyticsEvent>(event: T): void;
}
